<template>
   <AccountProfileField
      v-if="preferredName"
      :title="field.label"
      :details="preferredName"
      :fieldNotice="field.fieldNotice"
      data-cy="account-profile-preferred-name"
   />
</template>
<script setup lang="ts">
import type { AccountProfileField } from "@/components/account/accountTypes";
import { useUserStore } from "@/stores/userStore";

const userStore = useUserStore();

// Props
// ------------------------------------
const props = defineProps<{
   field: AccountProfileField;
}>();

// Computed
// ------------------------------------
const preferredName = computed(() => {
   return userStore.user?.name;
});
</script>
